export const SITE_LANGUAGES = ["en", "zh", "ja", "ko"];
